import styled from 'styled-components'
import { NewUserRecord } from 'Services/apiResponseTypes'
import { spacingSM } from 'Utils/styles/spacing'
import { frostedGlass, towerGray, zirconGray } from 'Utils/styles/colors'

const TableContainer = styled.div`
  overflow-y: auto;
  border: 1px solid ${zirconGray};
  border-radius: 4px;
  max-height: calc(80vh - 450px);
`

const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
`

const Thead = styled.thead`
  position: sticky;
  top: 0;
  background-color: ${frostedGlass};
  z-index: 1;
`

const TheadTr = styled.tr`
  box-shadow: 0 2px 2px -2px ${towerGray};
`

const Th = styled.th`
  padding: ${spacingSM};
  text-align: left;
  white-space: nowrap;
`

const Tr = styled.tr`
  &:nth-child(even) {
    background-color: ${frostedGlass};
  }

  &:hover {
    background-color: ${zirconGray};
  }
`

const Td = styled.td`
  padding: ${spacingSM};
  border-bottom: 1px solid ${zirconGray};
  max-width: 200px;
  overflow-wrap: break-word;
`

const ProgramList = styled.div`
  font-size: 12px;
`

const ProgramItem = styled.div`
  margin-bottom: 2px;
`

const MetadataList = styled.div`
  font-size: 12px;
  color: ${towerGray};
`

const EmptyState = styled.div`
  padding: ${spacingSM};
  text-align: center;
  color: ${towerGray};
  font-style: italic;
`

type NewUsersTabProps = {
  users: NewUserRecord[]
}

export const NewUsersTab = ({ users }: NewUsersTabProps) => {
  if (users.length === 0) {
    return <EmptyState>No new users to create</EmptyState>
  }

  return (
    <TableContainer>
      <Table>
        <Thead>
          <TheadTr>
            <Th>Email</Th>
            <Th>Name</Th>
            <Th>Country</Th>
            <Th>Invite Date</Th>
            <Th>Programs</Th>
            <Th>Metadata</Th>
          </TheadTr>
        </Thead>
        <tbody>
          {users.map((user) => (
            <Tr key={user.email}>
              <Td>{user.email}</Td>
              <Td>
                {user.first_name} {user.last_name}
              </Td>
              <Td>{user.country_code}</Td>
              <Td>{user.invite_date || 'Immediate'}</Td>
              <Td>
                {user.programs.length > 0 ? (
                  <ProgramList>
                    {user.programs.map((program) => (
                      <ProgramItem key={program.program_id}>
                        {program.program_name}
                        {program.start_date && ` (Start: ${program.start_date})`}
                        {program.end_date && ` (End: ${program.end_date})`}
                        {program.allowance_mod && ` - Allowance: ${program.allowance_mod}`}
                      </ProgramItem>
                    ))}
                  </ProgramList>
                ) : (
                  '-'
                )}
              </Td>
              <Td>
                {Object.keys(user.metadata).length > 0 ? (
                  <MetadataList>
                    {Object.entries(user.metadata).map(([key, value]) => (
                      <div key={key}>
                        {key}: {value}
                      </div>
                    ))}
                  </MetadataList>
                ) : (
                  '-'
                )}
              </Td>
            </Tr>
          ))}
        </tbody>
      </Table>
    </TableContainer>
  )
}
